module.exports = __webpack_public_path__ + "media/images/reklama-bg-245b70dc82e3d2c3ed5cec79717546fc.png";